<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 */
import { computed } from "vue";
import { useMainStore } from "@/store/main/index";
import { buildLinkObjFromWidget } from "@/composables/utils/router";

import { getWidgetSS } from "@/composables/core/func";

const Link = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Link.vue")
);

setTimeout(async () => {
  await getWidgetSS(["contact-information"]);
}, 500);

const mainStore = useMainStore();

const contactInfo = computed(() => {
  const copy = { ...mainStore.widgets?.["contact-information"] };
  delete copy?.title;

  return copy;
});
</script>

<template>
  <div
    class="contact-details contact-block--mx-default"
    v-if="mainStore.widgets?.['contact-information']"
  >
    <div class="contact-block__info-head">
      {{ mainStore.widgets?.["contact-information"]?.title }}
    </div>
    <ul>
      <template v-for="(item, name, index) in contactInfo" :key="index">
        <li
          class="contact-block__info-item d-flex al-center"
          v-if="name != 'web-address'"
        >
          <div class="d-flex icon al-center icon-default" v-html="item?.svg" />
          <Link :label="item?.title" :link="buildLinkObjFromWidget(item!)" class="c-white">
            {{ item?.title }}
          </Link>
        </li>
      </template>
    </ul>
  </div>
</template>

<style lang="scss">
.contact-details {
  padding-top: 96px;
  padding-bottom: 108px;

  @include maxq(desktop-2k) {
    padding-top: 65px;
    padding-bottom: 72px;
  }

  @include maxq(desktop-lg) {
    padding-top: 48px;
    padding-bottom: 55px;
  }

  @include maxq(desktop) {
    padding-top: 32px;
    padding-bottom: 32px;
  }

  @include maxq(tablet) {
    @include border(right);
  }

  @include border(bottom);

  .icon-default {
    --w: 56px;

    @include maxq(desktop-2k) {
      --w: 34px;
    }

    @include maxq(desktop-lg) {
      --w: 24px;
    }

    width: var(--w);
    height: var(--w);
    svg {
      width: var(--w);
      height: var(--w);
    }
  }
}
</style>
